// extracted by mini-css-extract-plugin
module.exports = {"root":"_1rUj2","bg":"g4SvW","arrow":"_38G0M"};